export interface CheckoutDirectDebitAccountDetails {
  accountName: string;
  accountNumber: string;
  sortCode: string;
}
